/** INTERFACES */
import { IOnboardingFunding } from "interfaces/IOnboardingFunding.interface";

class onboardingService {
  public saveOnboardingOnLocalStorage(data: IOnboardingFunding) {
    window.localStorage.setItem("onboardingFunding", JSON.stringify(data));
  }
}

export default new onboardingService();